export const loading_animation = {
    initial: { opacity: 1 },
    exit: { opacity: 0, pointerEvents: "none" },
};
